module.exports = __webpack_public_path__ + "img/mobile_map_monza.81a13072.svg";